import React from 'react';
import { List } from 'antd';
import { TFunction } from 'i18next';
import { SBox, SListItem } from 'components/Filter/Filter.styled';
import DebouncedCheckbox from './FilterDebouncedCheckbox';
import { FilterType, TextFacetLocal } from '../Filter.types';

interface FilterTextFacetOverlayProps {
  facet: TextFacetLocal;
  loading: boolean;
  isPosition: boolean;
  getTextChecked: (id: string, item: string) => boolean;
  setTextFilter: (id: string, item: string) => void;
  type?: FilterType;
  t: TFunction;
  isValidPosition: (label: string, t: TFunction) => boolean;
}

const FilterTextFacetOverlay: React.FC<FilterTextFacetOverlayProps> = ({
  facet,
  loading,
  isPosition,
  getTextChecked,
  setTextFilter,
  type,
  t,
  isValidPosition,
}) => {
  return (
    <SBox>
      <List
        dataSource={facet.items}
        loading={loading}
        renderItem={(item) => {
          if (isPosition && !isValidPosition(item.label, t)) {
            return null;
          }
          const isDisabled = !facet.active || item.numberOfItems === 0;
          return (
            <SListItem key={item.label}>
              <DebouncedCheckbox
                item={item}
                facet={facet}
                setTextFilter={setTextFilter}
                isDisabled={isDisabled}
                getTextChecked={getTextChecked}
                filterType={type}
                t={t}
              />
            </SListItem>
          );
        }}
        split={false}
      />
    </SBox>
  );
};

export default FilterTextFacetOverlay;
